import { apiRequest } from "./client";

function buildAssetFormData(file, metadata = {}) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("pageKey", metadata.pageKey || "home");
  formData.append("sectionKey", metadata.sectionKey || "general");
  formData.append("assetKey", metadata.assetKey || "image");
  return formData;
}

export const landingAssetsApi = {
  upload(projectId, file, metadata = {}, options = {}) {
    if (!file || typeof file.name !== "string") {
      return Promise.reject(new Error("Seleccioná un archivo válido"));
    }

    return apiRequest(`/projects/${projectId}/landing/assets`, {
      method: "POST",
      body: buildAssetFormData(file, metadata),
      onUploadProgress: options.onUploadProgress,
    });
  },

  remove(projectId, path) {
    return apiRequest(`/projects/${projectId}/landing/assets`, {
      method: "DELETE",
      body: JSON.stringify({ path }),
    });
  },
};
